import React, { MouseEventHandler, useContext, useEffect } from "react";
import { createPortal } from "react-dom";
// import "./BottomTab.scss";
import { alpha } from "../../utils/color";
import JigsawBottom from "./JigsawBottom";
import ScrollToTop from "../ComponentPendant/ScrollToTop";
import { ThemeContext } from "../../store/ThemeProvider";
import RootStore from "../../store/RootStore";
import { inject, observer } from "mobx-react";
import ReactSVG from "react-svg";
import useRealBottomTab from "./useRealBottomTab";
import {IComponent} from '../../component.d';
import {setContainer} from '../../utils/dom';
import AllForGallerySwitch from "../GalleryList/AllForGallerySwitch";

interface IOne {
  img: string;
  name?: string;
  active?: boolean;
  onClick?: MouseEventHandler;
  index: number;
  h2Color: string;
  mainColor: string;
}
const One = (props: IOne) => (
  <div
    className={"bottom-tab-one " + (props.active ? "active" : "")}
    style={{ color: !!props.active ? props.mainColor : props.h2Color }}
    onClick={props.onClick}
    data-stat={`BottomTab_${props.index}`}
  >
    {/*<img alt="" className={'tab-image'} src={props.img} />*/}
    <ReactSVG src={props.img} className={"tab-image"} />
    <span className={"one-tab-name"}>{props.name}</span>
  </div>
);
export interface IBottomTab {
  currentIndex: number;
  onClick: (index: number, tab: any) => void;
  my: boolean;
  order: boolean;
  component: IComponent | null;
  rootStore?: RootStore
}
const BottomTab = (props: IBottomTab) => {
  const { currentIndex, onClick, component} = props;
  const { filteredTabs, showNavigator } = useRealBottomTab(currentIndex);

  const {pagedataStore} = props.rootStore!;

  const { componentColor, backgroundColor, mainColor, h2Color } =
    useContext(ThemeContext);
  if (!showNavigator) {
    console.log("there is no tab to show");
    return null;
  }

  const style = !!component && !!component.container ? setContainer(component, componentColor) : {};
  // 根据设计图，这里的背景使用的页面颜色，而不是组件颜色，所以style先留空，需要的情况请使用backgroundColor

  const renderMethod = pagedataStore.renderMode == 'pc' ? (child:any)=>{
    return child;
  } : createPortal;

  return renderMethod(
    <>
      <div
        className="bt bottom-tab"
        style={{
          backgroundColor: component && component.container && component.container.useThemeColor === false ? component.container.componentBg : alpha(componentColor, 1),
        }}
      >
        {filteredTabs.map((tab, index) => {
          const isActive = currentIndex === index;
          return tab ? (
            <One
              key={tab.id}
              index={index}
              img={isActive ? tab.active : tab.inactive}
              name={tab.name}
              active={isActive}
              onClick={onClick.bind(null, index, tab)}
              mainColor={mainColor}
              h2Color={h2Color}
            />
          ) : null;
        })}
        {window.pageDetail.type != "form" && pagedataStore.renderMode == 'pc' &&
        Number(window.pageDetail.parent) ? (
          <div className="bottom-tab-one ">
            <AllForGallerySwitch />
          </div>
        ) : null}
      </div>
      {/*filteredTabs[currentIndex].id === 4 && <ScrollToTop />*/}
    </>,
    document.body
  );
};
export default inject("rootStore")(observer(BottomTab));
